export enum FailuresDataKeys {
    TIP_FOR_DEV = "TipForDevelopment",
    ORDER_NUMBER = "Order Number",
    NUMBER_OF_VISITS = "No. of Repeat Visits",
    HAS_TIPS_FOR_DEV = "HasTipForDevelopment",
}
